import React, {useState} from 'react';
import styles from './index.module.less';
import CodeEditor from "../../components/CodeEditor";
import { v4 } from 'uuid';

const example = [
  {
    id: v4(),
    isFolder: true,
    fileType: 'folder',
    label: 'exercises',
    hasCaret: true,
    isExpanded: true,
    icon: 'folder-open',
    className: 'folder',
    childNodes: [
      {
        id: v4(),
        isFolder: false,
        fileType: 'py',
        label: 'stack.py',
        hasCaret: false,
        icon: 'code',
        code: 'print("stack.py")',
        className: 'file',
      },
      {
        id: v4(),
        isFolder: false,
        fileType: 'py',
        label: 'url.py',
        hasCaret: false,
        icon: 'code',
        code: '# url.py',
        className: 'file',
      }
    ]
  },
  {
    id: v4(),
    isFolder: false,
    fileType: 'py',
    label: 'main.py',
    hasCaret: false,
    icon: 'code',
    code: '# main.py',
    className: 'file',
  },
  {
    id: v4(),
    isFolder: false,
    fileType: 'py',
    label: 'test.py',
    hasCaret: false,
    icon: 'code',
    code: '# test.py',
    className: 'file',
  },
];
const Example = () => {
  const [output, setOutput] = useState({
    message: '',
    stdout: '',
    stderr: ''
  });
  const handleRunCode = (directory) => {
    console.log(directory);
    setOutput({
      message: '执行成功，耗时2s，内存3MB',
      stdout: 'Hello Python'
    });
  };
  return (
    <div className={styles.example}>
      <CodeEditor directoryEditable defaultDirectory={example} output={output} onRunCode={handleRunCode} />
    </div>
  );
};

export default Example;
